/**
 * @generated SignedSource<<42cd4b5575244c147db01c4617a211c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patternId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routeId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tripId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "patternId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "tripId"
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routeId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledDeparture",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alertSeverityLevel",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveEndDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveStartDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceDay",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "realtimeState",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "directionId",
  "storageKey": null
},
v22 = [
  {
    "kind": "Variable",
    "name": "serviceDate",
    "variableName": "date"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "routeRoutes_TripStopsContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Pattern",
        "kind": "LinkedField",
        "name": "pattern",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TripStopsContainer_pattern"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Trip",
        "kind": "LinkedField",
        "name": "trip",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TripStopsContainer_trip"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "date",
                "variableName": "date"
              }
            ],
            "kind": "FragmentSpread",
            "name": "TripStopsContainer_route"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "routeRoutes_TripStopsContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Pattern",
        "kind": "LinkedField",
        "name": "pattern",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Trip",
        "kind": "LinkedField",
        "name": "trip",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stoptime",
            "kind": "LinkedField",
            "name": "stoptimesForDate",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stop",
                "kind": "LinkedField",
                "name": "stop",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "desc",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lat",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "zoneId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Alert",
                    "kind": "LinkedField",
                    "name": "alerts",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "realtimeArrival",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "realtimeDeparture",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "realtime",
                "storageKey": null
              },
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pickupType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dropoffType",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Route",
            "kind": "LinkedField",
            "name": "route",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              (v9/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pattern",
            "kind": "LinkedField",
            "name": "pattern",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v21/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longName",
            "storageKey": null
          },
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Agency",
            "kind": "LinkedField",
            "name": "agency",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fareUrl",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pattern",
            "kind": "LinkedField",
            "name": "patterns",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headsign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Stop",
                "kind": "LinkedField",
                "name": "stops",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Alert",
                    "kind": "LinkedField",
                    "name": "alerts",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alertDescriptionText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alertHash",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alertHeaderText",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alertUrl",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "activeDates",
                "args": null,
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "trips",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "alias": "day",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeDates",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "patternTrips",
                "args": null,
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "trips",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tripHeadsign",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tripLongName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tripShortName",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PatternTimetable",
                "kind": "LinkedField",
                "name": "patternTimetable",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ServiceValidityType",
                    "kind": "LinkedField",
                    "name": "validity",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "validFrom",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "validTo",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": [
                  {
                    "alias": "stoptimes",
                    "args": (v22/*: any*/),
                    "concreteType": "Stoptime",
                    "kind": "LinkedField",
                    "name": "stoptimesForDate",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Alert",
                "kind": "LinkedField",
                "name": "alerts",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "trips",
                "args": (v22/*: any*/),
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": [
                  {
                    "alias": "stoptimes",
                    "args": (v22/*: any*/),
                    "concreteType": "Stoptime",
                    "kind": "LinkedField",
                    "name": "stoptimesForDate",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scheduledArrival",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2cfe22a3ae84d55a9c10e1057286e1bb",
    "id": null,
    "metadata": {},
    "name": "routeRoutes_TripStopsContainer_Query",
    "operationKind": "query",
    "text": "query routeRoutes_TripStopsContainer_Query(\n  $patternId: String!\n  $tripId: String!\n  $routeId: String!\n  $date: String!\n) {\n  pattern(id: $patternId) {\n    ...TripStopsContainer_pattern\n    id\n  }\n  trip(id: $tripId) {\n    ...TripStopsContainer_trip\n    id\n  }\n  route(id: $routeId) {\n    ...TripStopsContainer_route_19b1FI\n    id\n  }\n}\n\nfragment RouteAgencyInfo_route on Route {\n  agency {\n    name\n    url\n    fareUrl\n    id\n  }\n}\n\nfragment RoutePatternSelect_route_19b1FI on Route {\n  shortName\n  mode\n  gtfsId\n  patterns {\n    code\n    directionId\n    headsign\n    stops {\n      name\n      id\n    }\n    activeDates: trips {\n      serviceId\n      day: activeDates\n      id\n    }\n    patternTrips: trips {\n      gtfsId\n      tripHeadsign\n      tripLongName\n      tripShortName\n      id\n    }\n    patternTimetable {\n      validity {\n        validFrom\n        validTo\n      }\n    }\n    tripsForDate(serviceDate: $date) {\n      stoptimes: stoptimesForDate(serviceDate: $date) {\n        scheduledDeparture\n        serviceDay\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment TripStopListContainer_trip on Trip {\n  route {\n    mode\n    type\n    gtfsId\n    color\n    shortName\n    id\n  }\n  pattern {\n    code\n    directionId\n    id\n  }\n  stoptimesForDate {\n    stop {\n      gtfsId\n      name\n      desc\n      code\n      lat\n      lon\n      zoneId\n      alerts {\n        alertSeverityLevel\n        effectiveEndDate\n        effectiveStartDate\n        id\n      }\n      id\n    }\n    realtimeArrival\n    realtimeDeparture\n    realtime\n    scheduledDeparture\n    serviceDay\n    realtimeState\n    pickupType\n    dropoffType\n  }\n  gtfsId\n}\n\nfragment TripStopsContainer_pattern on Pattern {\n  id\n}\n\nfragment TripStopsContainer_route_19b1FI on Route {\n  gtfsId\n  color\n  shortName\n  longName\n  mode\n  type\n  ...RouteAgencyInfo_route\n  ...RoutePatternSelect_route_19b1FI\n  agency {\n    phone\n    name\n    id\n  }\n  patterns {\n    alerts {\n      id\n      alertSeverityLevel\n      effectiveEndDate\n      effectiveStartDate\n    }\n    headsign\n    code\n    stops {\n      id\n      gtfsId\n      code\n      alerts {\n        id\n        alertDescriptionText\n        alertHash\n        alertHeaderText\n        alertSeverityLevel\n        alertUrl\n        effectiveEndDate\n        effectiveStartDate\n      }\n    }\n    trips: tripsForDate(serviceDate: $date) {\n      stoptimes: stoptimesForDate(serviceDate: $date) {\n        realtimeState\n        scheduledArrival\n        scheduledDeparture\n        serviceDay\n      }\n      id\n    }\n    activeDates: trips {\n      serviceId\n      day: activeDates\n      id\n    }\n    id\n  }\n}\n\nfragment TripStopsContainer_trip on Trip {\n  stoptimesForDate {\n    scheduledDeparture\n  }\n  ...TripStopListContainer_trip\n}\n"
  }
};
})();

node.hash = "e8e7a881048c95ba623319885d6874fd";

module.exports = node;
